import React from 'react';
import { Route, Switch,BrowserRouter } from 'react-router-dom';
import MainWrapper from '../MainWrapper';
import Landing from '../../Landing/index';
import NotFound404 from '../../DefaultPage/404/index';
import LockScreen from '../../Account/LockScreen/index';
import LogIn from '../../Account/LogIn/index';
import LogInPhoto from '../../Account/log_in_photo/index';
import Register from '../../Account/Register/index';
import RegisterPhoto from '../../Account/RegisterPhoto/index';
import WrappedRoutes from './WrappedRoutes';


const Router = () => (
  <MainWrapper>
    <main>
    <BrowserRouter basename={'/'}>
      <Switch>
        <Route basename={process.env.PUBLIC_URL} exact path="/" component={LogIn} />
        <Route basename={process.env.PUBLIC_URL} path="/404" component={NotFound404} />
        <Route basename={process.env.PUBLIC_URL} path="/lock_screen" component={LockScreen} />
        <Route basename={process.env.PUBLIC_URL} path="/log_in" component={LogIn} />
        <Route basename={process.env.PUBLIC_URL} path="/log_in_photo" component={LogInPhoto} />
        <Route basename={process.env.PUBLIC_URL} path="/register" component={Register} />
        <Route basename={process.env.PUBLIC_URL} path="/register_photo" component={RegisterPhoto} />
        <Route basename={process.env.PUBLIC_URL} path="/" component={WrappedRoutes} />
      </Switch>
      </BrowserRouter>
    </main>
  </MainWrapper>
);

export default Router;
